module.exports = __webpack_public_path__ + "img/contact.72c34853.svg";